import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';

export default class SignalRHandler {
  private readonly url: string;
  private readonly onConnected: (connection: HubConnection) => void;
  private readonly messageHandlers: Record<string, (...args: any[]) => void>;
  private readonly reconnectTimeout: number;
  private signalR?: HubConnection;
  private running = false;

  constructor(url: string, onConnected: (connection: HubConnection) => void, messageHandlers: Record<string, (...args: any[]) => void>, reconnectTimeout = 5000) {
    this.url = url;
    this.onConnected = onConnected;
    this.messageHandlers = messageHandlers;
    this.reconnectTimeout = reconnectTimeout;
  }

  start(): void {
    if (this.running) {
      return;
    }
    this.running = true;
    this.signalR = this.initSignalR();
  }

  stop(): void {
    this.running = false;
    this.signalR?.stop();
    this.signalR = undefined;
  }
  
  get connection(): HubConnection | undefined {
    return this.signalR;
  }

  private initSignalR(): HubConnection {
    const connection = new HubConnectionBuilder().withUrl(this.url).build();
    Object.entries(this.messageHandlers).forEach(([key, value]) => connection.on(key, value));
    connection.onclose(() => this.reconnectSignalR(connection)); // Restart connection after 5 seconds.

    this.reconnectSignalR(connection, 0);
    return connection;
  }

  private reconnectSignalR(connection: HubConnection, delay?: number): void {
    delay ??= this.reconnectTimeout;
    setTimeout(() => {
      if (!this.running) {
        return;
      }

      connection.start()
        .then(_ => this.onConnected(connection))
        .catch(err => {
          console.error(err);
          this.reconnectSignalR(connection);
        });
    }, delay);
  }
}
